const questionsAnswers = [
  {
    question: "Do you accept insurance?",
    answer: (
      <>
        Yes! I accept the following insurance plans:
        <br />
        <br />
        Aetna <br />
        BlueCross and BlueShield
        <br />
        Cigna and Evernorth
        <br />
        Oxford
        <br />
        <br />
        However, it's important to note that not all insurance plans cover
        therapy, or they may have specific requirements or limitations. Before
        scheduling a therapy session, I recommend that clients contact their
        insurance provider to inquire about their mental health benefits and
        coverage.
        <br />
        <br />
        For clients who do have insurance coverage, I'm happy to work with them
        to bill their insurance company directly for the cost of therapy.
        Depending on their insurance plan, clients may still be responsible for
        a copay or coinsurance amount at the time of their session. I'm always
        available to answer any questions or concerns about insurance coverage
        and payment options.
      </>
    ),
  },
  {
    question: "Do you have a sliding scale?",
    answer: (
      <>
        I understand that therapy can be costly, and I'm open to discussing
        payment options and sliding scale fees for clients who may have
        financial limitations. Ultimately, my goal is to make therapy accessible
        and effective for all of my clients.
      </>
    ),
  },
  {
    question: "How often will I need to attend therapy?",
    answer: (
      <>
        The frequency of therapy sessions will depend on the needs and goals of
        each individual client. In general, I recommend that clients attend
        therapy sessions on a weekly basis, especially in the beginning stages
        of treatment. This allows for consistent support and progress monitoring
        as clients work towards their goals.
        <br />
        <br />
        However, as therapy progresses and clients make progress, the frequency
        of sessions may decrease. Some clients may benefit from attending
        therapy sessions every other week, while others may only need to attend
        on a monthly basis. It's important to note that therapy is a
        collaborative process, and the frequency of sessions can always be
        adjusted based on the client's needs and progress.
      </>
    ),
  },
  {
    question: "Are online therapy sessions as effective as in-person sessions?",
    answer: (
      <>
        Research has shown that online therapy can be just as effective as
        traditional therapy for a range of mental health conditions, including
        depression, anxiety, and post-traumatic stress disorder (PTSD).
        <br />
        <br />
        In fact, online therapy offers several advantages over in-person
        therapy, such as greater accessibility and convenience for clients who
        may have mobility or transportation challenges. Online therapy can also
        be more affordable, as it eliminates the need for clients to travel to a
        physical office.
        <br />
        <br />
        Privacy is important to me. Virtual sessions are held on a video
        conference platform that is HIPPA-compliant and confidential.
      </>
    ),
  },
  {
    question: "What is your cancellation policy?",
    answer: (
      <>
        My cancellation policy requires that clients provide at least 48 hours'
        notice if they need to cancel. You can reschedule your session without
        charge. This allows me to offer the appointment slot to another client
        who may be in need of care.
        <br />
        <br />
        In the event that a client cancels with less than 48 hours' notice or
        fails to show up for a scheduled session, they will be charged the full
        cost. However, I understand that emergencies and unforeseen
        circumstances can arise, and I'm always willing to work with clients to
        find a solution that works for everyone.
      </>
    ),
  },
];

export default questionsAnswers;
